import styles from "./index.module.scss";

const EventLoader = () => (
    <div className={styles.loaderContainer}>
        <div className={styles.loader}></div>
        <div className={styles.loaderText}>Loading Event</div>
    </div>
);

export default EventLoader;